import { render, staticRenderFns } from "./MultilineChip.vue?vue&type=template&id=45bbdd98&scoped=true&"
import script from "./MultilineChip.vue?vue&type=script&lang=ts&"
export * from "./MultilineChip.vue?vue&type=script&lang=ts&"
import style0 from "./MultilineChip.vue?vue&type=style&index=0&id=45bbdd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bbdd98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
